import React from "react";
import styles from "./ScreenshotWatermark.module.css";
import LogoImage from "../icons/Loader/loaderLogo.png";

export const ScreenshotWatermark: React.FC = () => {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <img src={LogoImage} alt="DPS Control" className={styles.logo} />

        <div className={styles.links}>
          <span className={styles.link}>t.me/dpspremium_bot</span>
          <span className={styles.link}>dpscontrol.ru</span>
        </div>
      </div>
    </div>
  );
};
